const titleDeniedMessage = ({ options }) => {
  const refusal = {
    NO_ACTION: {
      TOTALVALUE_LOW: 'O valor do pedido está abaixo do mínimo permitido',
      TOTALVALUE_HIGH: 'O valor do pedido está acima do crédito permitido',
      USER_HAS_TRANSACTION: 'Você já possui um financiamento ativo',
      FILTER_BELOW_AGE: 'Idade abaixo do permitido',
      MAX_TRIES: 'O limite de tentativas foi excedido',
      DEFAULT: 'Crédito não disponível no momento',
    },
    PRICE_OUT_RANGE() {
      if (options.preApprovedCredit && options.preApprovedCredit.maxValue) {
        return 'O valor do pedido está acima do crédito disponível';
      }
      return refusal.DEFAULT.DEFAULT;
    },
    DENIED: {
      MAX_TRIES: 'O limite de tentativas foi excedido',
      USER_HAS_TRANSACTION: 'Você já possui um financiamento ativo',
      FILTER_BELOW_AGE: 'Idade abaixo do permitido',
      DEFAULT: 'Crédito não disponível no momento',
    },
    NO_ACTION_PREVIEW: {
      TOTALVALUE_LOW: 'O valor do pedido está abaixo do mínimo permitido',
      TOTALVALUE_HIGH: 'O valor do pedido está acima do crédito permitido',
      USER_HAS_TRANSACTION: 'Você já possui um financiamento ativo',
      MAX_TRIES: 'O limite de tentativas foi excedido',
      DEFAULT: 'Crédito não disponível no momento',
    },
    DEFAULT: {
      DEFAULT: 'Crédito não disponível no momento',
      ERROR: 'Tente novamente mais tarde',
    },
  };

  const refusalObj = refusal[options.result] ?? refusal.DEFAULT;
  const refusalReason = options?.refusalReason;

  if (refusalReason && refusalReason.includes('_ERROR')) return refusal.DEFAULT.ERROR;
  return typeof refusalObj === 'function' ? refusalObj() : refusalObj[refusalReason] ?? refusalObj.DEFAULT;
};

const infoDeniedMessage = ({ options }) => {
  const refusal = {
    NO_ACTION: {
      TOTALVALUE_LOW: `Para compras com o Parcelex, o valor mínimo do pedido deve ser de R$ 250.
            <br><br>Tente realizar um novo pedido com valor a partir de R$ 250.<br><br><a
            style="text-decoration: none" href="https://ajuda.parcelex.com.br/credito-indisponivel"
            target="_blank">Saiba Mais</a>`,
      TOTALVALUE_HIGH: `Para compras com o Parcelex, o valor máximo do pedido deve ser de R$ 10.000,00.
      <br><br>Tente realizar um novo pedido com valor abaixo de R$ 10.000,00.<br><br><a
      style="text-decoration: none" href="https://ajuda.parcelex.com.br/credito-indisponivel"
      target="_blank">Saiba Mais</a>`,

      DDD_NOT_FOUND: 'Verifique o campo telefone digitado e tente novamente.',

      USER_HAS_TRANSACTION: `Infelizmente não podemos seguir com sua compra porque <b>já existe um
            financiamento ativo associado a sua conta Parcelex.</b><br><br>Mas não se preocupe,
            seu limite será liberado novamente assim que todas as parcelas do financiamento
            atual forem pagas.`,

      FILTER_BELOW_AGE: `É necessário ter mais de 18 anos para realizar um financiamento
            de compra com o Parcelex.<br><br>Novas tentativas poderão bloquear seu CPF para
            compras com o Parcelex.<br><br><a style="text-decoration: none"
            href="https://ajuda.parcelex.com.br/credito-indisponivel" target="_blank">
            Saiba Mais</a>`,

      MAX_TRIES: `Só é possível realizar uma análise de crédito por pessoa para
            financiamentos de compras com o Parcelex.<br><br><b>Novas tentativas poderão
            bloquear seu CPF para  compras com o Parcelex.<br><br>Tente novamente amanhã.</b>
            <br><br><a style="text-decoration: none" href="https://ajuda.parcelex.com.br/credito-indisponivel"
            target="_blank">Saiba Mais</a>`,

      DEFAULT: `Ainda não temos crédito disponível para o seu perfil.<br>
          <br><b>Para fazer uma nova análise de crédito, aguarde 60 dias e tente
          novamente em nosso site.</b><br><br><a style="text-decoration: none"
          href="https://ajuda.parcelex.com.br/credito-indisponivel"
          target="_blank">Saiba mais</a>`,
    },
    PRICE_OUT_RANGE() {
      if (options.preApprovedCredit && options.preApprovedCredit.maxValue) {
        return `Você possui um limite de crédito pré-aprovado no valor de R$
        ${options.preApprovedCredit.maxValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        para sua próxima compra com o Parcelex.<br><br>Realize um novo pedido com valor total dentro do seu
        limite de crédito pré-aprovado.<br><br><a style="text-decoration: none"
        href="https://ajuda.parcelex.com.br/credito-indisponivel" target="_blank">Saiba mais</a>`;
      }
      return refusal.DEFAULT.DEFAULT;
    },
    NO_ACTION_PREVIEW: {
      TOTALVALUE_LOW: `Para compras com o Parcelex, o valor mínimo do pedido deve ser de R$ 250.
            <br><br>Tente realizar um novo pedido com valor a partir de R$ 250.<br><br><a
            style="text-decoration: none" href="https://ajuda.parcelex.com.br/credito-indisponivel"
            target="_blank">Saiba Mais</a>`,
      TOTALVALUE_HIGH: `Para compras com o Parcelex, o valor máximo do pedido deve ser de R$ 30000,00.
      <br><br>Tente realizar um novo pedido com valor abaixo de R$ 30000,00.<br><br><a
      style="text-decoration: none" href="https://ajuda.parcelex.com.br/credito-indisponivel"
      target="_blank">Saiba Mais</a>`,

      USER_HAS_TRANSACTION: `Infelizmente não podemos seguir com sua compra porque <b>já existe um
          financiamento ativo associado a sua conta Parcelex.</b><br><br>Mas não se preocupe,
          seu limite será liberado novamente assim que todas as parcelas do financiamento
          atual forem pagas.`,
      MAX_TRIES: `Só é possível realizar uma análise de crédito por pessoa para
          financiamentos de compras com o Parcelex.<br><br><b>Novas tentativas poderão
          bloquear seu CPF para  compras com o Parcelex.<br><br>Tente novamente amanhã.</b>
          <br><br><a style="text-decoration: none" href="https://ajuda.parcelex.com.br/credito-indisponivel"
          target="_blank">Saiba Mais</a>`,
      DEFAULT: `Ainda não temos crédito disponível para o seu perfil.<br>
          <br><b>Para fazer uma nova análise de crédito, aguarde 60 dias e tente
          novamente em nosso site.</b><br><br><a style="text-decoration: none"
          href="https://ajuda.parcelex.com.br/credito-indisponivel"
          target="_blank">Saiba mais</a>`,
    },
    DENIED: {
      MAX_TRIES: `Só é possível realizar uma análise de crédito por pessoa para
          financiamentos de compras com o Parcelex.<br><br><b>Novas tentativas poderão
          bloquear seu CPF para  compras com o Parcelex.<br><br>Tente novamente amanhã.</b>
          <br><br><a style="text-decoration: none" href="https://ajuda.parcelex.com.br/credito-indisponivel"
          target="_blank">Saiba Mais</a>`,
      USER_HAS_TRANSACTION: `Infelizmente não podemos seguir com sua compra porque <b>já existe um
          financiamento ativo associado a sua conta Parcelex.</b><br><br>Mas não se preocupe,
          seu limite será liberado novamente assim que todas as parcelas do financiamento
          atual forem pagas.`,
      FILTER_BELOW_AGE: `É necessário ter mais de 18 anos para realizar um financiamento
            de compra com o Parcelex.<br><br>Novas tentativas poderão bloquear seu CPF para
            compras com o Parcelex.<br><br><a style="text-decoration: none"
            href="https://ajuda.parcelex.com.br/credito-indisponivel" target="_blank">
            Saiba Mais</a>`,
      DEFAULT: `Ainda não temos crédito disponível para o seu perfil.<br>
            <br><b>Para fazer uma nova análise de crédito, aguarde 60 dias e tente
            novamente em nosso site.</b><br><br><a style="text-decoration: none"
            href="https://ajuda.parcelex.com.br/credito-indisponivel"
            target="_blank">Saiba mais</a>`,
    },
    DEFAULT: {
      DEFAULT: `Ainda não temos crédito disponível para o seu perfil.<br>
        <br><b>Para fazer uma nova análise de crédito, aguarde 60 dias e tente
        novamente em nosso site.</b><br><br><a style="text-decoration: none"
        href="https://ajuda.parcelex.com.br/credito-indisponivel"
        target="_blank">Saiba mais</a>`,
      ERROR: `Ops! Algo deu errado.<br><br> É possível que estejamos passando
            por instabilidades técnicas. <br><br> Por favor, tente novamente mais
            tarde.<br><br><a style="text-decoration: none"
            href="https://wa.me/5521971556988" target="_blank">Preciso de ajuda</a>`,
    },
  };

  const refusalObj = refusal[options.result] ?? refusal.DEFAULT;
  return typeof refusalObj === 'function' ? refusalObj() : refusalObj[options.refusalReason] ?? refusalObj.DEFAULT;
};

export default {
  titleDeniedMessage,
  infoDeniedMessage,
};
